<template>
  <div>
    <!-- {{ data.item.id }} -->
    <div
      class="cursor-pointer"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
      @click="findingsList(data.item.id)"
    >

      <img
        v-if="!isHover"
        src="@/assets/images/icons/findings.png"
        width="35"
        height="35"
        alt="Search icon"
      >
      <img
        v-else
        src="@/assets/images/icons/findings-animated.gif"
        width="50"
        height="50"
        alt="Animated search icon"
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    getAllData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
  methods: {
    findingsList(id) {
      this.$swal({
        title: 'Loading...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          this.$swal.showLoading()
        },
      })

      axios
        .get(`/internal-audit/${id}`)
        .then(res => {
          const findingList = decryptData(res.data.payload).data.resource.findings
          this.$swal.close()
          this.ApprovalRow(findingList)
        }).catch(error => {
          if (error) {
            this.$swal.close()
            this.$swal({
              icon: 'error',
              title: 'Failed to load findings',
              text: 'Please try again later.',
            })
          }
        })
    },
    ApprovalRow(name) {
      // console.log(name)
      this.$swal.fire({
        title: '<strong><u>Findings </u></strong>',
        icon: 'info',
        html: name.length ? `<div style="max-height: 500px; overflow-y: scroll;">${name.map(item => `
          <p><strong>Auditor :</strong>${item.auditor?.name}</p> 
          <p>${item.finding}</p> 
          <p>${item.reference_doc}</p>
          <div style="display: flex; justify-content: center; lign-item: center; gap: 10px">
          ${item.attachment_nc.map((file, index) => `<a href="${file.url}" target="_blank"> (${index + 1})📄</a>`).join('')} 
            </div>
          <hr/>`).join('')}</div>` : '<p>No Findings Found!</p>',
      })
    },
  },
}
</script>
